import type { ReactNode } from "react";
import { Text } from "../../elements/text/text";

/**
 * Cart Product List Title Component
 *
 * Displays a header section for product lists with:
 * - Main title (e.g., "Products")
 * - Article count subtitle (e.g., "11 articles distributed over 3 products")
 *
 */

export interface CartProductListTitleMicrocopies {
  title: string;
  articleCount: string;
}

export interface CartProductListTitleProps {
  microcopies: CartProductListTitleMicrocopies;
  className?: string;
}

export function CartProductListTitle(
  props: Readonly<CartProductListTitleProps>
): ReactNode {
  return (
    <div className={`flex flex-col gap-1 ${props.className || ""}`}>
      <Text variant="body-lg">{props.microcopies.title}</Text>
      <Text variant="body-md">{props.microcopies.articleCount}</Text>
    </div>
  );
}
